<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="tocf"><a href="#/xhtml/Introduction">Introduction</a></h2>
<h2 class="tocc"><a href="#/xhtml/Chapter01"><span class="tsp">Chapter 1</span> Buchanan’s Boy – <em class="italic">Early Years</em></a></h2>
<h2 class="tocc"><a href="#/xhtml/Chapter02"><span class="tsp">Chapter 2</span> The First Favourites – <em class="italic">Esmé Stuart and the Earl of Huntly</em></a></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter03" title="Link target outside of Sample"><span class="tsp">Chapter 3</span> The Devil on the Forth – <em class="italic">King James and Witchcraft</em></span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter04" title="Link target outside of Sample"><span class="tsp">Chapter 4</span> Above the Black Turnpike – <em class="italic">The Gowrie Conspiracy</em></span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter05" title="Link target outside of Sample"><span class="tsp">Chapter 5</span> Two Mothers, One Wife – <em class="italic">Elizabeth, Mary, Anne</em></span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter06" title="Link target outside of Sample"><span class="tsp">Chapter 6</span> A Family Man – <em class="italic">The King’s Children and Cousin</em></span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter07" title="Link target outside of Sample"><span class="tsp">Chapter 7</span> Shadows at the King’s Right Hand – <em class="italic">Royal Associates and the Path to the English Crown</em></span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter08" title="Link target outside of Sample"><span class="tsp">Chapter 8</span> The King at Leisure – <em class="italic">Poetry and the Hunt</em></span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter09" title="Link target outside of Sample"><span class="tsp">Chapter 9</span> Lion Versus Unicorn – <em class="italic">The Ill-Made Marriage of Scotland and England</em></span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter10" title="Link target outside of Sample"><span class="tsp">Chapter 10</span> The Nation’s Second Scotsman – <em class="italic">The Rise and Fall of Robert Carr</em></span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter11" title="Link target outside of Sample"><span class="tsp">Chapter 11</span> Steenie – <em class="italic">George Villiers, Duke of Buckingham</em></span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter12" title="Link target outside of Sample"><span class="tsp">Chapter 12</span> The Forerunner of Revenge – <em class="italic">The Death of King James</em></span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter13" title="Link target outside of Sample"><span class="tsp">Chapter 13</span> Solomon Weighed – <em class="italic">Reputation and Legacy</em></span></h2>
<h2 class="tocbt"><span href="#/xhtml/Illustration" title="Link target outside of Sample">Illustration Sources</span></h2>
<h2 class="tocb"><span href="#/xhtml/Notes" title="Link target outside of Sample">Notes and References</span></h2>
<h2 class="tocb"><span href="#/xhtml/Bibliography" title="Link target outside of Sample">Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?1c93a66f